// Handlers for ALERT and COMMAND_ACK WebSocket messages from the control plane

import type { MessageCallbacks } from './types';
import type { Alert } from '../../types/control';

let _alertIdSeq = 0;
function _nextAlertId() { return `alert_${Date.now()}_${++_alertIdSeq}`; }

export function handleAlert(obj: any, cb: MessageCallbacks): boolean {
  if (obj.kind !== 'ALERT') return false;

  const alert: Alert = {
    id: _nextAlertId(),
    severity: obj.severity ?? 'INFO',
    alert_kind: obj.alert_kind ?? 'unknown',
    message: obj.message ?? '',
    data: obj.data ?? {},
    received_at: new Date().toISOString(),
  };

  if (cb.addAlert) {
    cb.addAlert(alert);
  }

  // Surface WARN/CRIT as activity events so they appear in the dashboard feed
  if (alert.severity !== 'INFO' && cb.pushActivity) {
    cb.pushActivity({
      id: alert.id,
      kind: 'ALERT',
      title: alert.message,
      detail: JSON.stringify(alert.data),
      timestamp: alert.received_at,
      severity: alert.severity === 'CRIT' ? 'critical' : 'warning',
    });
  }

  return true;
}

export function handleCommandAck(obj: any, cb: MessageCallbacks): boolean {
  if (obj.kind !== 'COMMAND_ACK') return false;
  if (cb.onCommandAck) {
    cb.onCommandAck({ kind: 'COMMAND_ACK', id: obj.id, command: obj.command, status: obj.status, detail: obj.detail ?? '' });
  }
  return true;
}
